<template>
  <main class="main" id="main">
    <div class="top_line">
      <div class="container">
        <h1>Доставка раков</h1>
      </div>
    </div>
    <section class="section s-seo">
      <div class="container">
        <div class="seo_box">
          <div class="bottom-wrapper">
            <div class="line"></div>
            <h2 style="margin-top:2%;">Доставка раков в г.{{city.name}}</h2>
            <p>Заказать доставку свежих вареных раков на дом можно через наш сервис <router-link to="/">хочу-поесть.рф</router-link></p>
            <p>Какое настоящее пивное застолье или поход в баню возможно без раков? Верно! Никакое! В Росси раки считаются лучшей пивной закуской и если раньше Вы покупали рыбу или креветки только потому что не знали где купить раков или как их варить, то сейчас этот вопрос уже решен.</p>
            <p>Хотите заказать доставку живых раков? Это тоже возможно.</p>
            <h2 style="margin-top:2%;">Как заказать раков в г.{{city.name}}</h2>
            <p>Выбирайте размер, определяйте количество и заказывайте в два клика. Наслаждайтесь любимым пенным вместе с вкуснейшими раками, сваренными по традиционным и оригинальным рецептам в раковарнях нашего города.</p>
            <h2 style="margin-top:2%;">Закажите живых раков и сварите их сами</h2>
            <p>Закажите доставку живых раков домой или на свой загородный участок. Сварите их сами так как Вы любите. Не знаете рецепт правильной варки раков? Наш сайт Вам в этом поможет.</p>
            <center><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/global/articles/cancer1.jpg" alt="заказать раков" width="700" /></center>
            <h2 style="margin-top:2%;">Как правильно варить раков?</h2>
            <p>Мы сделали для Вас специальную подборку оригинальных рецептов. Они помогут тем, кто решил сварить их самостоятельно. Знали ли Вы что раков можно варить не только в воде, но и в молоке и пиве? Все рецепты как правильно варить раков <router-link to="/blog">здесь</router-link>.</p>
            <router-link :to="'/product/11'" tag="div">
              <button class="menu_item_btn seo">ХОЧУ ПОЕСТЬ!</button>
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'cancer',
  props: ['city']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/articles/cancer.vue